import { useTranslation } from 'react-i18next'

import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'

export const DefaultFallbackPage = () => {
    const { t } = useTranslation()
    return (
        <WithHeaderSection
            headerSection={
                <>
                    <h1 className='singlesetting__section__title'>
                        {t('comingSoon')}
                    </h1>
                </>
            }
        >
            <div className='settings settings__fields'>
                {t('workInProgress')}
            </div>
        </WithHeaderSection>
    )
}
